import { getApiUrl, getCurrentLanguageId, openComponentInPopup } from "./common";
import HttpClient from "./http-client";
import { initFirstVisitorPopup } from "./main";
import { PopupWidth } from "./popup";


export default class FirstVisitorInitializer{
    popupConfig: FirstVisitorPopupConfig;

    constructor() {
        const hide = sessionStorage.getItem('first-visitor-popup-disable');
        if (hide == 'true') {
            return;
        }
        sessionStorage.setItem('first-visitor-popup-disable', 'true');
        this.init();
    }

    private async init() {
        this.popupConfig = await this.getPopupConfig();
        if(!this.popupConfig.enabled)
            return;

        setTimeout(async () => {
            await openComponentInPopup('FirstVisitorPopup', null, { id: 'first-visitor-popup', width: this.popupConfig.windowSize });
            await initFirstVisitorPopup();
        }, this.popupConfig.delayMs);
    }

    private async getPopupConfig(): Promise<FirstVisitorPopupConfig> {
        const client = new HttpClient();
        const url = `${getApiUrl()}/coupon/get-first-visitor-config`
        const response = await client.fetch(url, {
            headers: {
                'Current-Language-Id': getCurrentLanguageId()
            }
        });

        if (!response.ok) return;
        return await response.json() as FirstVisitorPopupConfig;
    }
}

interface FirstVisitorPopupConfig {
    enabled: boolean,
    windowSize: PopupWidth;
    delayMs: number;
}
